import React from 'react';
import { useSelector } from 'react-redux';
import * as queryString from 'query-string';
import PropTypes, { any } from 'prop-types';
import SplashBall from '../../components/Splash/splashBall';
import { getLabelByTypeId } from '../../utils/types';
import PrintCard from './PrintCard';
import { getPrintCardType } from '../../utils/matchScorePrintPage';
import styles from './matchScorePrintPage.scss';
import { getMatchSheetData } from '../../actions/event-profile-actions';
import { getIsMatchSheetDataLoading, getMatchSheetDataSelector } from '../../selectors/eventActionSelectors';
import { PRINT_ALL_MATCHES } from './config';

const MatchScorePrintPage = ({ location }) => {
    const queryParams = queryString.parse(location.search);
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { scoringTypes } = coreUI.types.tms.division.tournament;
    const isLoadingMatchSheetData = useSelector(getIsMatchSheetDataLoading);
    const { data: matchSheetData } = useSelector(getMatchSheetDataSelector);

    const matchId = queryParams?.matchId;
    const matchIds = queryParams?.matchesArray?.split('_');

    if (isLoadingMatchSheetData || !matchSheetData) {
        return <SplashBall title="Printing Match" description="Loading..." />;
    }

    let scoringFormat = queryParams.scoringFormat !== 'null' ? queryParams.scoringFormat : '4';
    const scoreSheetType = queryParams.scoreSheetType ? queryParams.scoreSheetType : 'official';
    let type = getPrintCardType(scoreSheetType, scoringFormat);
    const pageFormat = queryParams.pageFormat ? queryParams.pageFormat : 'halfSheet';
    let scoringFormatDisplay = scoringFormat ? getLabelByTypeId(scoringTypes, scoringFormat) : 'NA';

    // "it's a printers term. 2up means two match sheets are printing on one page" - e
    let hasBreak = true;
    if (pageFormat === 'halfSheet') {
        hasBreak = false;
    }

    let renderMatches;
    switch (true) {
        case matchId === PRINT_ALL_MATCHES:
            renderMatches = matchSheetData.matches;
            break;

        case !!matchId:
            renderMatches = matchSheetData.matches.filter(match => match.matchId === matchId);
            break;

        case !!matchIds:
            renderMatches = matchSheetData.matches.filter(match => matchIds?.includes(match.matchId));
            break;
        default:
            renderMatches = matchSheetData.matches;
            break;
    }

    return (
        <div className={styles.container}>
            {renderMatches.map((match, index) => {
                const { matchId, positionOneMembers, positionTwoMembers, officialName, courtNumber, matchPositionDisplay, drawNameDisplay, matchScoringTypeId, matchScoringTypeName } = match;
                    let displayNameOne = 'NA';
                    let displayNameTwo = 'NA';
                    let displayNameThree = 'NA';
                    let displayNameFour = 'NA';

                    if (positionOneMembers) {
                         displayNameOne = positionOneMembers[0]?.displayName && positionOneMembers[0]?.displayName !== '' ? positionOneMembers[0]?.displayName : 'NA';
                         displayNameTwo = positionOneMembers[1]?.displayName && positionOneMembers[1]?.displayName !== '' ? positionOneMembers[1]?.displayName : 'NA';
                    }
                    if (positionTwoMembers) {
                        displayNameThree = positionTwoMembers[0]?.displayName && positionTwoMembers[0]?.displayName !== '' ? positionTwoMembers[0]?.displayName : 'NA';
                        displayNameFour = positionTwoMembers[1]?.displayName && positionTwoMembers[1]?.displayName !== '' ? positionTwoMembers[1]?.displayName : 'NA';
                    }

                    if (matchScoringTypeId !== null) {
                        scoringFormat = matchScoringTypeId;
                        scoringFormatDisplay = matchScoringTypeName;
                        type = getPrintCardType(scoreSheetType, matchScoringTypeId);
                    }

                    if (index % 2 !== 0 && pageFormat === 'halfSheet') {
                        hasBreak = true;
                    }
                    if (index + 1 === renderMatches.length) {
                        hasBreak = false;
                    }

                    return (
                        <PrintCard
                            key={matchId}
                            type={type}
                            hasBreak={hasBreak}
                            drawName={drawNameDisplay}
                            matchPosition={matchPositionDisplay}
                            refereeName={officialName}
                            courtNumber={courtNumber || 'NA'}
                            scoringFormat={scoringFormat}
                            scoringFormatDisplay={scoringFormatDisplay}
                            displayNameOne={displayNameOne}
                            displayNameTwo={displayNameTwo}
                            displayNameThree={displayNameThree}
                            displayNameFour={displayNameFour}
                            match={match}
                        />
                    );
            })}
        </div>
    );
};

export default {
    component: MatchScorePrintPage,
    loadData: ({ dispatch }, match) => dispatch(getMatchSheetData({ eventId: match.params.eventId, drawId: match.params.drawId })),
};

MatchScorePrintPage.propTypes = {
    location: PropTypes.objectOf(any),
};

MatchScorePrintPage.defaultProps = {
    location: {},
};
